// ANGEL FLIGHT — M4: Whiteout (the campaign's fourth sortie — a new biome + a
// new RHYTHM).
//
// First light over a snowbound mountain checkpoint as a whiteout rolls in. Where
// M1–M3 are a STEADY escalation, M4 is a SIEGE that breathes: the storm comes in
// SURGES and LULLS. A brutal armor push slams the bird, then the whiteout closes
// and the field goes near-quiet for a beat — the lull is your window to let the
// hull Field-Repair and reset flares — before the next, heavier wall hits. The
// twist is the rhythm: survive the surge, recover in the lull, brace for worse.
// It is the roster's heaviest ARMOR sortie (brute walls every surge) and leans on
// the RPG/flare interplay (screamers cluster in the surges). Friendlies still
// push through the white, so target discipline holds — CHECK YOUR FIRE.
//
// Pure data. The new `frozen-checkpoint` theme drives the bright cold whiteout
// palette (config/render.ts themes); the ColorWorld reads it generically. The
// objective stays 'survive' (the 'boss' kind is still reserved for a capstone) —
// the novelty is the surge/lull WAVE STRUCTURE, not a new objective kind.

import type { MissionDef } from '../core/types';

export const whiteout: MissionDef = {
  id: 'm4-whiteout',
  name: 'Whiteout',
  biome: 'Frozen Checkpoint — Whiteout',
  objective: 'survive',
  theme: 'frozen-checkpoint',
  durationMs: 130_000,
  brief:
    'First light on the pass — and a whiteout rolling in. The storm comes in waves: it breaks, it lulls, it breaks harder. Use the quiet to patch the bird and reset your flares, then brace for the wall. Friendlies are pushing through the white — CHECK YOUR FIRE. Hold until exfil.',
  waves: [
    // PROBE — the storm's first breath. A light contact to set the cold.
    { atMs: 1_500, spawns: { shambler: 4, runner: 1 }, banner: 'FIRST LIGHT — CONTACT' },

    // SURGE 1 — the storm breaks: the first armor push leads the horde.
    { atMs: 12_000, spawns: { shambler: 6, runner: 4, brute: 1 }, banner: 'THE STORM BREAKS' },

    // LULL — the whiteout closes in. A thin trickle; let the bird breathe.
    { atMs: 27_000, spawns: { shambler: 3 }, banner: 'EYE OF THE STORM' },

    // SURGE 2 — armor in the white, RPGs open up, friendlies pushing through.
    { atMs: 35_000, spawns: { runner: 5, marauder: 2, screamer: 2, trooper: 1, brute: 1 }, banner: 'ARMOR IN THE WHITE' },

    // LULL.
    { atMs: 51_000, spawns: { runner: 3 }, banner: 'EYE OF THE STORM' },

    // SURGE 3 — they have our range: an RPG + rifle crossfire out of the murk.
    { atMs: 59_000, spawns: { screamer: 3, marauder: 3, runner: 5, trooper: 1 }, banner: 'THEY HAVE OUR RANGE' },

    // LULL — the deepest quiet, right before the wall.
    { atMs: 75_000, spawns: { shambler: 3 }, banner: 'EYE OF THE STORM' },

    // SURGE 4 — whiteout proper: a brute wall with the whole horde behind it.
    { atMs: 83_000, spawns: { shambler: 8, runner: 6, brute: 2, screamer: 2, marauder: 2 }, banner: 'WHITEOUT' },

    // SHORT LULL — ominous; the storm gathers.
    { atMs: 100_000, spawns: { runner: 3 }, banner: 'EYE OF THE STORM' },

    // SURGE 5 — last light: the final siege wall, troopers caught in it.
    { atMs: 107_000, spawns: { runner: 9, shambler: 8, brute: 2, screamer: 3, marauder: 3, trooper: 2 }, banner: 'LAST LIGHT — HOLD' },

    // FINAL CRUSH — everything left, thrown at the bird as exfil turns in.
    { atMs: 121_000, spawns: { runner: 10, shambler: 10, brute: 3, screamer: 2 }, banner: 'EXFIL INBOUND — HOLD THE BIRD' },
  ],
};
